<template>
  <div class="page-content">
    <component :is="componentName" :items="data" />
  </div>
</template>

<script>
import EducationFullScreen from "./EducationFullScreen.vue";
import EducationMobile from "./EducationMobile.vue";

export default {
  /**
   * @typedef {Array} EducationsData
   * @prop {String} name
   * @prop {String} education_type
   * @prop {String} status
   * @prop {String} progress_slides
   * @prop {Boolean} has_tests
   * @prop {String} progress_tests
   * @prop {String} button_course_text
   * @prop {String} button_exam_text
   * @prop {String} course_url
   * @prop {String} exam_url
   * @prop {String} date_start
   * @prop {String} date_end
   * @prop {Boolean} button_course_status
   * @prop {Boolean} button_exam_status
   * @prop {Boolean} exam_with_curator
   * @prop {null|String} exam_pin_code
   */

  components: {
    EducationFullScreen,
    EducationMobile
  },
  data() {
    return {
      componentName: 'EducationFullScreen',
      data: []
    };
  },
  mounted() {
    // Определение компонента на основе текущей ширины экрана
    this.updateComponent();
    window.addEventListener('resize', this.updateComponent);

    axios
      .get('/education-data')
      .then((r) => {
        this.data = r.data;
      });
  },
  beforeDestroy() {
    // Удаление обработчика события перед уничтожением компонента
    window.removeEventListener('resize', this.updateComponent);
  },
  methods: {
    updateComponent() {
      const width = window.innerWidth;
      if (width > 1200) {
        this.componentName = 'EducationFullScreen';
      } else {
        this.componentName = 'EducationMobile';
      }
    }
  }
};
</script>
